const WorksHyfye = () => { 
    return (
      <section id="how_it_work" className="bg_black_dark overflow_hide">
        <div className="container">
          <div className="row">
            
            {/* Left Title Section */}
            <div className="col-lg-4">
              <div className="title_default_light title_border">
                <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">How Hyfye Works</h4>
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                  Hyfye transforms everyday actions into real earnings. Whether you're creating, engaging, or simply participating — you're building value and earning rewards, instantly.
                </p>
                <a href="https://www.pinksale.finance/launchpad/bsc/0x837f3E47CF89E716D22DbB9Bb38cedAb46248A1B"
                  className="btn btn-default page-scroll video animation" 
                  data-animation="fadeInUp" data-animation-delay="0.6s" target="_blank">
                  Get Started <i className="ion-ios-arrow-thin-right"></i>
                </a>
              </div>
            </div>
  
            {/* Steps Section */}
            <div className="col-lg-8">
              <div className="row">
  
                {/* Step 1 */}
                <div className="col-lg-6">
                  <div className="work_box res_md_mt_20">
                    <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                      <i className="ion-card"></i>
                    </div>
                    <div className="work_inner">
                      <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">Set Up Your Wallet</h4>
                      <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                        Connect a crypto wallet like MetaMask or TrustWallet to collect and manage your Hyfye earnings.
                      </p>
                    </div>
                  </div>
                </div>
  
                {/* Step 2 */}
                <div className="col-lg-6">
                  <div className="work_box res_md_mt_20">
                    <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                      <i className="ion-android-share-alt"></i>
                    </div>
                    <div className="work_inner">
                      <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">Engage and Earn</h4>
                      <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                        Every action — posting, liking, commenting, sharing — rewards you with Hyfye coins instantly.
                      </p>
                    </div>
                  </div>
                </div>
  
                {/* Step 3 */}
                <div className="col-lg-6">
                  <div className="work_box mt-4">
                    <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                      <i className="ion-android-favorite-outline"></i>
                    </div>
                    <div className="work_inner">
                      <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">Tip and Appreciate</h4>
                      <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                        Show gratitude by tipping creators, service providers, and contributors around the world — instantly and seamlessly.
                      </p>
                    </div>
                  </div>
                </div>
  
                {/* Step 4 */}
                <div className="col-lg-6">
                  <div className="work_box mt-4">
                    <div className="work_icon animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                      <i className="ion-android-people"></i>
                    </div>
                    <div className="work_inner">
                      <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">Grow and Prosper</h4>
                      <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                        As more users tip, earn, and engage, the Hyfye economy grows — boosting the value of your participation.
                      </p>
                    </div>
                  </div>
                </div>
  
              </div>
            </div>
  
          </div>
        </div>
  
        {/* Background Ripple Effects */}
        <div className="ripple_effect_left_bottom">
          <div className="circle_bg1">
            <span></span><span></span><span></span><span></span><span></span><span></span>
          </div>
        </div>
        <div className="ripple_effect_right_top">
          <div className="circle_bg1">
            <span></span><span></span><span></span><span></span><span></span><span></span>
          </div>
        </div>
      </section>
    );
  }
  
  export default WorksHyfye;
  